// extracted by mini-css-extract-plugin
export var empty = "styles-module--empty--k3YfB";